import './RefundPolicy.scss';

const RefundPolicy = () => {
  return (
    <div className='container'>
      <h1 className='head'>
        <b>REFUND POLICY :</b>
      </h1>
      <div className='p'>
        <li>
          The booking amount paid at the time of booking is non-refundable. In
          case, after booking you decide not to avail the services, you can
          email us at snapcityinpune@gmail.com and the balance amount will be
          waved off.
        </li>
        <li>
          Any cancellation on booking, prior to 15 days from shoot date will be
          non-refundable.
        </li>
        <li>
          You cannot reschedule the shoot date after the confirmation of
          booking.
        </li>
        <li>
          In case, if the studio is closed on the day of the shoot due to some
          unavoidable situations, we can reschedule your shoot to a mutually
          convenient date.
        </li>
      </div>
    </div>
  );
};

export default RefundPolicy;
